/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React from 'react';
import { useNode, useEditor } from '@craftjs/core';
import { TextField } from '@mui/material';
import { Input as CommonInput } from '../../../common/ui-kit/inputs/Input';
import { UIEditorBlockWidth, WidthSelectControl } from './WidthSelectControl';

import styles from './UIEditorBlocks.module.scss';

type EmptyBlockProps = {
  size: UIEditorBlockWidth;
};

export const EmptyBlock = (props: Partial<EmptyBlockProps>) => {
  const { connectors, selected } = useNode((state) => ({
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));
  const { connect, drag } = connectors!;
  const { size } = {
    ...EmptyBlockDefaultProps,
    ...props,
  };

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <div
      className={styles.container}
      style={{
        width: size,
      }}
      ref={(ref) => connect(drag(ref!))}
    >
      <div className={styles.textBlockContainer}>
        {enabled ? (
          <CommonInput
            className={styles.titleElement}
            placeholder={'Empty'}
            readOnly={true}
          />
        ) : (
          <div className={styles.textContainer}></div>
        )}
      </div>
    </div>
  );
};

const EmptyBlockSettings = () => {
  const { actions, props } = useNode((node) => ({
    props: node.data.props as EmptyBlockProps,
  }));
  const { setProp } = actions;

  return (
    <>
      <WidthSelectControl props={props} setProp={setProp} />
    </>
  );
};

export const EmptyBlockDefaultProps: EmptyBlockProps = {
  size: UIEditorBlockWidth.Quarter,
};

EmptyBlock.craft = {
  defaultProps: EmptyBlockDefaultProps,
  related: {
    settings: EmptyBlockSettings,
  },
};
